(function expertiseSliderFrontend($, window) {
    $(document).on('cms.ready', ready);
    // $(document).ready(ready);

    // TODO: Handle add/remove elements in the ring -- currently only the slider is updated.

    // globals
    let logged_in = false; // Nice-to-have: Logged in as a Contenda variable.

    let slickSettings = {
        adaptiveHeight: true,
        fade: true,
    };

    function ready() {
        logged_in = $('body.logged-in').length;

        if(logged_in) {
            // Set up intersect listener on document since that's the only way we can listen to newly added elements
            $(document).on('cms.intersect', '.expertise-slider', intersect);

            $(document).on('sectionExpertiseSlider.removeItem', function removeItem(e, obj) {
                // Contenda.log('removeItem', e, obj);
                $('.expertise-slider').trigger('sectionExpertiseSlider.frontend.update');
            });

            $(document).on('sectionExpertiseSlider.addItem', function addItem(e, obj) {
                // Contenda.log('addItem', e, obj);
                $('.expertise-slider').trigger('sectionExpertiseSlider.frontend.update');
            });

        } else {
            $('.expertise-slider').on('cms.intersect', intersect);
        }

        function intersect(evt, entry, $elm) {
            Contenda.log('intersect', evt, entry, $elm, this);
            $elm.trigger('sectionExpertiseSlider.frontend.ready');

            // Set up resize listener
            let _debounce = false,
                _width = $(window).width();
            $(window).on('resize', function debouncedReinitialize() {
                if(_debounce) {
                    clearTimeout(_debounce);
                }
                _debounce = setTimeout(function checkWidthResized() {
                    if($(this).width() == _width) {
                        return;
                    }

                    $elm.trigger('sectionExpertiseSlider.frontend.ready');

                    _width = $(this).width();
                }, 200);
            });
        }
    }

    $(document).on('sectionExpertiseSlider.frontend.ready', function frontendReady(evt) {
        let $section = $(evt.target),
            $wheel = $section.find('.wheel'),
            $service = $section.find('.service'),
            half_wheel_width = $wheel.width() / 2,
            half_grey_border_width = 12,
            ring_rotation = 0;

        // console.log($section, 'ready');

        $service.css({'transform-origin': '50% calc(50% + ' + half_wheel_width + 'px - ' + half_grey_border_width + 'px)'});

        // TODO: slickSettings are "global" and doing this causes issues if there's more than one slider.
        slickSettings.prevArrow = $section.find('.expertise-slider__prev');
        slickSettings.nextArrow = $section.find('.expertise-slider__next');
        slickSettings.appendArrows = $section.find('.expertise-slider__navigation');

        if(logged_in) {
            let $slider = $section.find('.expertise-slider__elements').not('.clone');
            // Clone angular container and hide the original one (to keep bindings)
            let $parent = $slider.parent(),
                $clone = $slider.clone();

            $clone.addClass('clone');
            if($slider.siblings('.clone').length > 0) {
                let $old_clones = $slider.siblings('.clone');
                $old_clones.remove();
            }

            $slider.hide();

            $clone.appendTo($parent);

            reinitializeSlick($clone);

            $section.off('sectionExpertiseSlider.frontend.update')
                .on('sectionExpertiseSlider.frontend.update', function updateSlider(evt) {
                let $section = $(this),
                    $clones = $section.find('.expertise-slider__elements.clone');

                if($clones.slick) {
                    slickSettings.initialSlide = $clones.slick('slickCurrentSlide');
                }

                // Destroy old clone(s)
                $clones.remove();

                // Trigger ready to "simply" rebuild slider and wheel
                $section.trigger('sectionExpertiseSlider.frontend.ready');
            });
        } else {
            let $slider = $section.find('.expertise-slider__elements');
            reinitializeSlick($slider);
        }

        // Wheel for Expertise slider/Services section
        // Source: https://codepen.io/mikkelaastrup/pen/LYGMaxv
        let number_of_services = $service.length;
        let rotation_per_service = (number_of_services < 1) ? 360 : 360 / number_of_services;
        let start_rotation = 90;

        let $slider = $section.find('.expertise-slider__elements');

        if($slider.length > 1) {
            $slider = $slider.filter('.clone');
        }

        if(slickSettings.initialSlide && $section.data('ring_rotation')) {
            ring_rotation = $section.data('ring_rotation');
        }

        // get theme from initial active service and apply to expertise-slider section
        $section.attr('data-theme', $service.filter('.active').data('theme'));

        // align all services around the wheel
        $service.each(function alignService(i, elm) {
            let current_rotation = i * rotation_per_service + start_rotation,
                $elm = $(elm);

            // move up, and rotate
            $elm.css('transform', 'translate3d(-50%, calc(-50% - '+half_wheel_width+'px + ' + half_grey_border_width + 'px), 0) rotate(' + -current_rotation + 'deg)');

            // rotate the texts back
            $elm.find('span').css('transform', 'translate3d(0,0,0) rotate(' + (current_rotation) + 'deg)');

            // rotate selected service to active position
            $elm.off('click').on('click', function goToSlide() {
                $slider.slick('slickGoTo', $(this).index());
            });
        });

        $slider.off('beforeChange').on('beforeChange', updateRotation);

        function updateRotation(event, slick, currentSlide, nextSlide) {
            ring_rotation += shortestDistance(currentSlide, nextSlide, number_of_services) * rotation_per_service;

            $wheel.css('transform', 'translate3d(0,0,0) rotate(' + ring_rotation + 'deg)');

            // Counter-rotate the image/text inside the services
            $service.find('span').each(function transformSpans(i, elm) {
                $(elm).css('transform', 'translate3d(0,0,0) rotate(' + (i * rotation_per_service + start_rotation - ring_rotation) + 'deg)');
            });

            // set the active service
            let $active_service = $service.removeClass('active').eq(nextSlide);
            $active_service.addClass('active');

            // get theme from active service and apply to expertise-slider section
            $section.attr('data-theme', $active_service.data('theme'));

            // magic
            requestAnimationFrame(function scrollIntoView() {
                // If the slider is not in view: Scroll it into view
                let sliderElm = $('.expertise-slider__container', $section).get(0),
                    bounds = sliderElm.getBoundingClientRect();
                if (bounds.bottom > window.innerHeight || bounds.top < 0) {
                    sliderElm.scrollIntoView({behavior: "smooth", block: "end", inline: "nearest"});
                }
            });

            // Save ring_rotation on section in case we need to reinitialize later
            $section.data('ring_rotation', ring_rotation);
        }
    });

    /**
     * Calculate the shortest distance from the active index to a clicked index
     * @param active_index
     * @param clicked_index
     * @param total_elements
     * @returns {number}
     */
    function shortestDistance(active_index, clicked_index, total_elements) {

        // one direction
        let a = (clicked_index - active_index) % total_elements;
        // other direction
        let b = (total_elements + a) % total_elements;

        let diff = Math.abs(b) <= Math.abs(a) ? b : a;

        if (diff > (total_elements / 2)) {
            diff = diff - total_elements;
        }

        return diff;
    }

    function reinitializeSlick($slider) {
        // destroy slick and remove all depending classes
        $slider.hide();
        if($slider.hasClass('slick-initialized') && $slider.slick) {
            slickSettings.initialSlide = $slider.slick('slickCurrentSlide');
            $slider.slick('unslick');
        }
        setTimeout( function showSlider() {
            $slider.show();
            $slider.slick(slickSettings);
        }, 100);
    }

})(jQuery, window);